import { UseQueryOptions, useQueries } from '@tanstack/react-query';

import { REQUEST_HEADERS } from 'services/constants';

export function useReadFilesFromURL(
  url?: string | string[],
  options?: UseQueryOptions<string | undefined, unknown, string>
) {
  const urls = Array.isArray(url) ? url : [url];

  return useQueries({
    queries: urls.map((url) => ({
      queryKey: [url],
      queryFn: () => {
        if (!url) {
          return Promise.reject('Please provide a URL to read from.');
        }

        return fetch(url, {
          headers: REQUEST_HEADERS,
        }).then((res) => {
          if (res.status === 200) {
            return res.text();
          }

          return undefined;
        });
      },
      ...options,
      enabled: !!url,
      staleTime: Infinity,
    })),
  });
}
